module.exports = __webpack_public_path__ + "img/problems-5.49178025.png";